<template>
  <div class="all">
    <div class="x">
      <el-dialog title="同步数据时间范围" :visible.sync="dialogVisible" width="38%">
        <div class="mainDialog">
          <el-form label-width="100px" :model="form" style="margin-top: 30px" ref="form" :rules="rules">
            <el-form-item label="开始时间" prop="StartTime">
              <el-date-picker :picker-options="startDatePicker" v-model="form.StartTime" type="date" placeholder="选择日期" style="width: 100%"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="EndTime">
              <el-date-picker :picker-options="overDatePicker" v-model="form.EndTime" type="date" placeholder="选择日期" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="formAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import derive from '@/api/derive';
export default {
  components: {},
  props: {
    Qid: {
      type: String,
      default: ''
    },
    ProjectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rules: {
        StartTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        EndTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }]
      },
      form: {
        StartTime: '',
        EndTime: ''
      },
      dialogVisible: false,
      startDatePicker: {
        disabledDate: time => {
          if (this.form.EndTime) {
            return time.getTime() > new Date(this.form.EndTime);
          }
        }
      },
      overDatePicker: {
        disabledDate: time => {
          if (this.form.StartTime) {
            return time.getTime() < new Date(this.form.StartTime).setHours(0, 0, 0, 0) + 1000 * 3600 * 24;
          }
        }
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    closeDialog() {
      this.$emit('closeTogeter', false);
    },
    formAdd() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = {
            StartTime: this.form.StartTime,
            EndTime: this.form.EndTime,
            Id: this.Qid,
            ProjectId: this.ProjectId
          };
          console.log(params);
          const res = await derive.setDataApi(params);
          if (res.Status != -1) {
            this.$message.success('同步成功');
          }

          this.$emit('closeTogeter', false);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  /* display: flex;
  justify-content: center; */
  /* width: 100%; */
  height: 79vh;
  overflow: auto;
  padding: 20px;
}

.head {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.mtTable {
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
}

/deep/ .el-dialog__title {
  color: #fff;
}

/* /deep/ .el-input__inner {
  width: 400px;
} */

.mainDialog {
  width: 80%;
  margin: 0 auto;
}
</style>
